import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { NavParams } from 'ionic-angular';
import { Content } from 'ionic-angular';



import { RolresponsaveisService } from '../../../providers/rolresponsaveis-service';

import { MenuService } from '../../../providers/menu-service';
import { AlertService } from '../../../providers/alert-service';
import { UsuarioService } from '../../../providers/usuario-service';
import { GestaoPcaService } from '../../../providers/gestao-pca-service';
import { ModalDetalhesRolResponsaveisPage } from '../../modais/modal-detalhes-rol-responsaveis/modal-detalhes-rol-responsaveis';
import { ModalPortariasPage } from '../../modais/modal-portarias/modal-portarias';

import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { IMyDrpOptions, IMyDateRangeModel, IMyDateRange } from 'mydaterangepicker';

import { ModulosController } from '../modulos-controller';

declare var require: any;
declare var jsPDF: any;

@Component({
  selector: 'page-rol-responsaveis',
  templateUrl: 'rol-responsaveis.html',
  providers: [
    RolresponsaveisService
  ]
})

export class RolResponsaveisPage extends ModulosController {
  @ViewChild(Content) content: Content;
  // Lista Construtora da Página
  cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  dataMask = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  phoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  emailMask = [/\^[A-Za-z0-9._%+-]\+/, '@', /[A-Za-z0-9.-]\+/, '.', /[A-Za-z]\{2,4}\$/];
  rolDeResponsaveis: any;
  usuario: any;
  isJurisdicionado: boolean = false;
  isCGE: boolean;
  PCAAtiva: any;
  shownGroup: any = [];
  shownGroupAtos: any = [];
  shownGroupTelefones: any = [];
  loading: boolean = true;
  buscandoCEPFuncional: boolean = false;
  buscandoCEPPessoal: boolean = false;
  telaListagem: boolean = true;
  telaCriacao: boolean = false;
  edicaoResponsavel: boolean = false;
  criacaoResponsavel: boolean = false;
  visualizacaoResponsavel: boolean = false;
  listaEstados: any = [];
  listaCidadesEnderecoPessoal: any = [];
  listaCidadesEnderecoFuncional: any = [];
  listaTiposTelefone: any = [];
  listaCargos: any = [];
  listaAtos: any = [];
  listaFuncoes: any = [];
  cpfPreenchido: boolean = false;
  cpfCarregado: boolean = true;
  cpfInvalido: boolean = false;
  funcaoSelecionada: boolean = false;
  telefonesParaRemover: any = [];
  periodosParaRemover: any = [];
  sexoItems: any = [];

  pessoaFuncaoAtual: any = {
    "idPca": "",
    "idPessoaFuncao": 0,
    "dsDescricaoCargo": "",
    "idFuncao": null,
    "cargo": {
      "idCargo": null,
      "nomeCargo": ""
    },
    "listaPeriodoFuncao": [
      // ],
      // "listaPortarias": [
    ]
  };
  pessoaAtual: any = {
    "idPessoa": 0,
    "nomePessoa": "",
    "cpf": "",
    "sexo": 0,
    "dataNascimento": "",
    "idEmailPessoal": 0,
    "emailPessoal": "",
    "idEmailFuncional": 0,
    "emailFuncional": "",
    "enderecoPessoal": {
      "idEndereco": 0,
      "logradouro": "",
      "numero": "",
      "complemento": "",
      "bairro": "",
      "idCidade": null,
      "cidade": "",
      "idEstado": null,
      "estado": "",
      "cep": "",
      "tipoEndereco": "RESIDENCIAL"
    },
    "enderecoFuncional": {
      "idEndereco": 0,
      "logradouro": "",
      "numero": "",
      "complemento": "",
      "bairro": "",
      "idCidade": null,
      "cidade": "",
      "idEstado": null,
      "estado": "",
      "cep": "",
      "tipoEndereco": "COMERCIAL"
    },
    "telefones": [
    ]
  };

  telefoneParaAdicionar: any = {
    dsContato: '',
    dsTipoContato: ''
  }
  periodoFuncaoParaAdicionar: any = {
    "idPeriodoFuncao": 0,
    "dataInicio": "",
    "dataFim": "",
    "idPessoaFuncao": 0,
    "portarias": ""
  }
  // portariaParaAdicionar: any = {
  //   "idPortaria": 0,
  //   "dataNomeacao": "",
  //   "dataPublicacao": "",
  //   "tipoAto": {
  //     "idTipoAto": 0,
  //     "dsTipoAto": ""
  //   },
  //   "numPaginado": "",
  //   "idPessoaFuncao": 0
  // }

  private myDatePickerNomeacaoOptions: IMyDpOptions;
  private myDatePickerPublicacaoOptions: IMyDpOptions;
  private myDateRangePickerOptions: IMyDrpOptions;
  private myDatePickerNascimentoOptions: IMyDpOptions;

  selectedDateRange: IMyDateRange;

  selectedText: string = '';
  border: string = 'none';

  placeholderTxt: string = 'Selecione o Período...';

  private disabled: boolean = true;

  public mesAno: string = '01/1999';

  order: string = 'pessoa.nomePessoa';
  reverse: boolean = false;

  codigoModulo: any = null;

  analise: any = null;

  selecionarTodosChecked = false;

  desabilitarBotaoCarregar = true;

  //Construtor da Página
  constructor(public rolresponsaveisService: RolresponsaveisService,
    public usuarioService: UsuarioService,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public gestaoPcaService: GestaoPcaService,
    public alertService: AlertService,
    private cdRef: ChangeDetectorRef,
    public menuService: MenuService) {

    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.analise = this.navParams.get('analise');

    this.mesAno = '01/1999';

    //let date = new Date();
    this.myDatePickerNomeacaoOptions = {
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
      dateFormat: 'dd/mm/yyyy',
      todayBtnTxt: 'Hoje',
      firstDayOfWeek: 'su',
      disableWeekends: false,
      editableDateField: true,
      openSelectorOnInputClick: true,
      showClearDateBtn: false,
      openSelectorTopOfInput: true,
      showSelectorArrow: false
    };

    this.myDatePickerPublicacaoOptions = {
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
      dateFormat: 'dd/mm/yyyy',
      todayBtnTxt: 'Hoje',
      firstDayOfWeek: 'su',
      disableWeekends: false,
      editableDateField: true,
      openSelectorOnInputClick: true,
      showClearDateBtn: false,
      componentDisabled: true,
      openSelectorTopOfInput: true,
      showSelectorArrow: false
    };

    this.myDatePickerNascimentoOptions = {
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
      dateFormat: 'dd/mm/yyyy',
      todayBtnTxt: 'Hoje',
      firstDayOfWeek: 'su',
      disableWeekends: false,
      editableDateField: true,
      openSelectorOnInputClick: true,
      showClearDateBtn: false,
      componentDisabled: false,
      openSelectorTopOfInput: true,
      showSelectorArrow: false
    };

    this.usuario = this.usuarioService.obtemUsuario();
    this.isJurisdicionado = this.usuarioService.isJurisdicionado();
    this.isCGE = this.usuarioService.isCGE();
    this.PCAAtiva = this.gestaoPcaService.getPCA();
    this.pessoaFuncaoAtual.idPca = this.PCAAtiva.id;

    this.myDateRangePickerOptions = {
      dateFormat: 'dd/mm/yyyy',
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
      firstDayOfWeek: 'su',
      showApplyBtn: false,
      showClearDateRangeBtn: false,
      selectBeginDateTxt: 'Selecione a Data de Início',
      selectEndDateTxt: 'Selecione a Data de Fim',
      openSelectorOnInputClick: true,
      editableDateRangeField: false,
      width: '100%',
      showSelectorArrow: false,
      maxYear: this.PCAAtiva.dsAnoexercicio,
      markCurrentYear: false,
      indicateInvalidDateRange: true,
      markCurrentDay: false,
      markCurrentMonth: false,
      disableSince: { year: parseInt(this.PCAAtiva.dsAnoexercicio) + 1, month: 1, day: 1 }
    };

    this.mesAno = '01/' + this.PCAAtiva.dsAnoexercicio;

    // console.log("mesAno: " + this.mesAno);

    this.codigoModulo = this.navParams.get('analise').idModuloPca;

    usuarioService.getUsuario().subscribe(broadcastVariable => {
      this.usuario = broadcastVariable.usr;
      this.isJurisdicionado = this.usuarioService.isJurisdicionado();
      this.isCGE = false;
    });

    this.carregarRolReponsaveis();
    this.carregarTiposTelefones();
    this.carregarCargos();
    this.carregarTiposAtos();
    this.carregarEstados();
    this.carregarFuncoes();

    this.setModuloId(1);
    this.setIdModuloPca(this.codigoModulo);

    //this.selectedDateRange = { beginDate: { year: this.PCAAtiva.dsAnoexercicio - 1, month: 1, day: 1 }, endDate: { year: this.PCAAtiva.dsAnoexercicio, month: 12, day: 31 } };
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }

  carregarRolReponsaveis() {
    this.loading = true;
    this.rolresponsaveisService.getRolResponsaveis(this.PCAAtiva.id).subscribe(data => {
      this.rolDeResponsaveis = data;
      this.selecionarTodosChecked = false;
      this.desabilitarBotaoCarregar = this.rolDeResponsaveis.length > 0;
      this.loading = false;
    },
      error => {
        console.log("erro: " + error);
        this.loading = false;
      });
  }

  importarRolReponsaveisAnoAnterior() {
    this.alertService.mostraModalConfirmacao("Importar Rol de Responsáveis do ano anterior",
      "Deseja continuar a importação do Rol de Responsáveis do ano anterior?",
      callback => {
        if (callback) {
          this.loading = true;
          this.rolresponsaveisService.importarRolResponsaveisAnoAnterior(this.PCAAtiva.id).subscribe(() => {
            this.rolresponsaveisService.getRolResponsaveis(this.PCAAtiva.id).subscribe(data => {
              this.rolDeResponsaveis = data;
              this.loading = false;
              this.desabilitarBotaoCarregar = this.rolDeResponsaveis.length > 0;
              this.alertService.mostraAlerta("", "Importação de Rol de Responsáveis finalizada!");
            },
              error => {
                this.desabilitarBotaoCarregar = false;
                this.loading = false;
                this.alertService.mostraAlerta("Ocorreu um erro ao carregar: ", error.mensagem);
              });
          }, error => {
            this.desabilitarBotaoCarregar = false;
            this.loading = false;
            this.alertService.mostraAlerta("Ocorreu um erro ao importar: ", error.mensagem);
          });
        }
      }
    );
  }

  carregarFuncoes() {
    this.rolresponsaveisService.buscarFuncoes().subscribe(data => {
      this.listaFuncoes = data;
    },
      error => {
        console.log("erro: " + error);
      });
  }

  cpf_mask(v) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  carregarTiposTelefones() {
    this.rolresponsaveisService.buscarTiposTelefone().subscribe(data => {
      this.listaTiposTelefone = data;

      var index = this.listaTiposTelefone.indexOf('Fax');
      this.listaTiposTelefone.splice(index, 1);

    },
      error => {
        console.log("erro: " + error);
      });
  }

  carregarCargos() {
    this.rolresponsaveisService.buscarCargos().subscribe(data => {
      this.listaCargos = data;
    },
      error => {
        console.log("erro: " + error);
      });
  }

  carregarTiposAtos() {
    this.rolresponsaveisService.buscarTiposAtos().subscribe(data => {
      this.listaAtos = data;
    },
      error => {
        console.log("erro: " + error);
      });
  }

  carregarEstados() {
    this.rolresponsaveisService.buscarEstados().subscribe(data => {
      this.listaEstados = data;
    },
      error => {
        console.log("erro: " + error);
      });
  }

  redirecionarParaGestaoPCA() {
    console.log('entrei');
  }

  buscarPessoaPorCPF(cpf) {
    cpf = cpf.replace(/[^\w\s]/gi, '');

    this.cpfCarregado = false;
    this.rolresponsaveisService.buscarPessoaPorCPF(cpf).subscribe(data => {
      if (data != null &&
        data.nomePessoa != "") {
        this.pessoaAtual = data;
        this.carregarCidadesDosEnderecosParaEdicao(this.pessoaAtual);
      }
      else {
        this.limparCamposPessoa(false);
      }
      this.cpfPreenchido = this.cpfCarregado = true;
      this.funcaoSelecionada = false;
    },
      error => {
        console.log("erro: " + error);
        this.cpfPreenchido = this.cpfCarregado = true;
      });
  }

  fileChange(event) {
    this.rolresponsaveisService.xmlRolUpload(event, this.PCAAtiva.id).subscribe(data => this.rolDeResponsaveis = data.rolResponsavel, error => console.log("erro: " + error));
  }

  apresentaModal(titulo: String, jsonObjeto: any) {
    let modal = this.modalCtrl.create(ModalDetalhesRolResponsaveisPage, { param1: titulo, param2: jsonObjeto });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal) {
      }
    });
    modal.present();
  };

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      let index = this.shownGroup.indexOf(group);
      this.shownGroup.splice(index, 1);
    } else {
      this.shownGroup.push(group);
    }
  }
  isGroupShown(group) {
    return this.shownGroup.indexOf(group) != -1;
  };
  toggleGroupAtos(group) {
    if (this.isGroupShownAtos(group)) {
      let index = this.shownGroupAtos.indexOf(group);
      this.shownGroupAtos.splice(index, 1);
    } else {
      this.shownGroupAtos.push(group);
    }
  }
  isGroupShownAtos(group) {
    return this.shownGroupAtos.indexOf(group) != -1;
  };
  toggleGroupTelefones(group) {
    if (this.isGroupShownTelefones(group)) {
      let index = this.shownGroupTelefones.indexOf(group);
      this.shownGroupTelefones.splice(index, 1);
    } else {
      this.shownGroupTelefones.push(group);
    }
  }
  isGroupShownTelefones(group) {
    return this.shownGroupTelefones.indexOf(group) != -1;
  };

  adicionarResponsavel(campoCPF) {
    this.telaListagem = this.cpfPreenchido = false;
    this.telaCriacao = this.criacaoResponsavel = true;
  }

  voltarParaListagem() {
    this.telaListagem = true;
    this.telaCriacao =
      this.criacaoResponsavel =
      this.edicaoResponsavel =
      this.cpfPreenchido =
      this.funcaoSelecionada =
      this.visualizacaoResponsavel = false;
    this.limparCampos();
    this.carregarRolReponsaveis();
  }

  excluirResponsavel(pessoaFuncao, dsFuncao) {
    this.loading = true;
    this.alertService.mostraModalConfirmacao("Excluir responsável",
      "Confirma a exclusão do responsável (" + pessoaFuncao.pessoa.nomePessoa
      + ") da função " + dsFuncao + " ?", retorno => {
        if (retorno) {
          this.rolresponsaveisService.excluirResponsavel(pessoaFuncao.idPessoaFuncao).subscribe(data => {
            this.alertService.mostraAlerta("", "Responsável excluído com sucesso!");
            this.carregarRolReponsaveis();
          },
            error => {
              this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir o responsável:" + error);
              console.log("erro: " + error);
              this.loading = false;
            });
        }
      });
  }

  excluirSelecionados() {

    let qtdeSelecionados = 0;
    this.rolDeResponsaveis.forEach(rol => rol.listaPessoaFuncao.forEach(item => qtdeSelecionados += item.checked));

    if (qtdeSelecionados == 0) {
      this.alertService.mostraAlerta("", "Selecione pelo menos um registro para excluir!");
      return;
    }

    let registrosTexto = qtdeSelecionados + (qtdeSelecionados == 1 ? " registro?" : " registros?");

    this.alertService.mostraModalConfirmacao("Excluir " + registrosTexto,
      "Deseja continuar com a exclusão de " + registrosTexto,
      callback => {
        if (callback) {
          this.loading = true;

          let listaId = [];

          this.rolDeResponsaveis.forEach(rol => {
            rol.listaPessoaFuncao
              .filter(item => item.checked)
              .map(item => item.idPessoaFuncao)
              .forEach(id => {
                listaId.push(id);
              });;
          }
          );

          this.rolresponsaveisService.deletarLista(listaId).subscribe(data => {
            this.loading = false;
            this.carregarRolReponsaveis();
            this.alertService.mostraAlerta("", data.mensagem);
          }, error => {
            this.loading = false;
            this.carregarRolReponsaveis();
            this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir: " + error.mensagem);
          });
        }
      }
    );
  }

  editarResponsavel(pessoaFuncao) {
    this.loading = true;
    this.scrollToTop();
    this.pessoaFuncaoAtual = pessoaFuncao;
    this.pessoaAtual = pessoaFuncao.pessoa;
    this.carregarCidadesDosEnderecosParaEdicao(pessoaFuncao.pessoa);
    this.telaListagem = false;
    this.telaCriacao = this.cpfPreenchido = this.edicaoResponsavel = this.funcaoSelecionada = true;
    this.loading = false;
    //this.myDateRangePickerOptions.maxYear = this.PCAAtiva.dsAnoexercicio;
  }

  visualizarResponsavel(pessoaFuncao) {
    this.loading = true;
    this.scrollToTop();
    this.pessoaFuncaoAtual = pessoaFuncao;
    this.pessoaAtual = pessoaFuncao.pessoa;
    this.carregarCidadesDosEnderecosParaEdicao(pessoaFuncao.pessoa);
    this.telaListagem = false;
    this.telaCriacao = this.cpfPreenchido = this.visualizacaoResponsavel = this.funcaoSelecionada = true;
    this.loading = false;
    //this.myDateRangePickerOptions.maxYear = this.PCAAtiva.dsAnoexercicio;
  }

  scrollToTop() {
    this.content.scrollToTop();
  }

  carregarCidadesDosEnderecosParaEdicao(pessoa) {
    this.rolresponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoPessoal.idEstado).subscribe(data => {
      this.listaCidadesEnderecoPessoal = data;
      this.pessoaAtual.enderecoPessoal.idCidade = pessoa.enderecoPessoal.idCidade;
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
      console.log("erro: " + error);
    });

    this.rolresponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoFuncional.idEstado).subscribe(data => {
      this.listaCidadesEnderecoFuncional = data;
      this.pessoaAtual.enderecoFuncional.idCidade = pessoa.enderecoFuncional.idCidade;
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
      console.log("erro: " + error);
    });
  }

  onCEPAlteradoEnderecoFuncional() {
    if (this.cepValido(this.pessoaAtual.enderecoFuncional.cep)) {
      this.buscandoCEPFuncional = true;
      this.rolresponsaveisService.buscarEnderecoPorCEP(this.pessoaAtual.enderecoFuncional.cep).subscribe(data => {
        console.log(data);
        if (data != undefined && !data.erro) {
          this.pessoaAtual.enderecoFuncional.logradouro = data.logradouro;
          this.pessoaAtual.enderecoFuncional.bairro = data.bairro;

          let estadoTemp = this.listaEstados.filter((estado) => data.uf.toUpperCase() == estado.dsSigla.toUpperCase())[0];
          if (estadoTemp != null) {
            this.pessoaAtual.enderecoFuncional.idEstado = estadoTemp.idEstado;
            this.pessoaAtual.enderecoFuncional.estado = data.uf;
          }

          this.rolresponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoFuncional.idEstado).subscribe(dataCidades => {
            this.listaCidadesEnderecoFuncional = dataCidades;

            let cidadeTemp = this.listaCidadesEnderecoFuncional.filter((cidade) => data.localidade.toUpperCase() == cidade.nmCidade.toUpperCase())[0];
            if (cidadeTemp != null) {
              this.pessoaAtual.enderecoFuncional.idCidade = cidadeTemp.idCidade;
              this.pessoaAtual.enderecoFuncional.cidade = data.localidade;
            }
          }, error => {
            console.log("erro: " + error);
          });
        }
        else {
          this.limparCamposEnderecoFuncional();
        }
        this.buscandoCEPFuncional = false;
      },
        error => {
          console.log("erro: " + error);
          this.limparCamposEnderecoFuncional();
          this.buscandoCEPFuncional = false;
        });
    }
    else {
      this.limparCamposEnderecoFuncional();
    }
  }

  onCEPAlteradoEnderecoPessoal() {
    if (this.cepValido(this.pessoaAtual.enderecoPessoal.cep)) {
      this.buscandoCEPPessoal = true;
      this.rolresponsaveisService.buscarEnderecoPorCEP(this.pessoaAtual.enderecoPessoal.cep).subscribe(data => {
        if (data != undefined && !data.erro) {
          this.pessoaAtual.enderecoPessoal.logradouro = data.logradouro;
          this.pessoaAtual.enderecoPessoal.bairro = data.bairro;

          let estadoTemp = this.listaEstados.filter((estado) => data.uf.toUpperCase() == estado.dsSigla.toUpperCase())[0];
          if (estadoTemp != null) {
            this.pessoaAtual.enderecoPessoal.idEstado = estadoTemp.idEstado;
            this.pessoaAtual.enderecoPessoal.estado = data.uf;
          }

          this.rolresponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoPessoal.idEstado).subscribe(dataCidades => {
            this.listaCidadesEnderecoPessoal = dataCidades;

            let cidadeTemp = this.listaCidadesEnderecoPessoal.filter((cidade) => data.localidade.toUpperCase() == cidade.nmCidade.toUpperCase())[0];
            if (cidadeTemp != null) {
              this.pessoaAtual.enderecoPessoal.idCidade = cidadeTemp.idCidade;
              this.pessoaAtual.enderecoPessoal.cidade = data.localidade;
            }
          }, error => {
            console.log("erro: " + error);
          });
        }
        else {
          this.limparCamposEnderecoPessoal();
        }
        this.buscandoCEPPessoal = false;
      },
        error => {
          console.log("erro: " + error);
          this.limparCamposEnderecoPessoal();
          this.buscandoCEPPessoal = false;
        });
    }
    else {
      this.limparCamposEnderecoPessoal();
    }
  }

  cepValido(cep) {
    return cep.toString().replace('-', '').length == 8;
  }

  limparCamposEnderecoFuncional() {
    this.pessoaAtual.enderecoFuncional.logradouro
      = this.pessoaAtual.enderecoFuncional.bairro
      = this.pessoaAtual.enderecoFuncional.idEstado
      = this.pessoaAtual.enderecoFuncional.estado
      = this.pessoaAtual.enderecoFuncional.idCidade
      = this.pessoaAtual.enderecoFuncional.cidade = "";
  }

  limparCamposEnderecoPessoal() {
    this.pessoaAtual.enderecoPessoal.logradouro
      = this.pessoaAtual.enderecoPessoal.bairro
      = this.pessoaAtual.enderecoPessoal.idEstado
      = this.pessoaAtual.enderecoPessoal.estado
      = this.pessoaAtual.enderecoPessoal.idCidade
      = this.pessoaAtual.enderecoPessoal.cidade = "";
  }

  adicionarTelefone() {
    if (this.telefoneParaAdicionar.dsContato != '' &&
      this.telefoneParaAdicionar.dsTipoContato != '') {

      let valido = false;
      // if (this.telefoneParaAdicionar.dsTipoContato == 'Telefone Fixo') {
      //   if (this.telefoneParaAdicionar.dsContato.replace(/[^\w\s]/gi, '').replace(' ', '').replace('_', '').length == 10) {
      //     valido = true;
      //   }
      // } else if (this.telefoneParaAdicionar.dsTipoContato == 'Telefone Celular') {
      //   if (this.telefoneParaAdicionar.dsContato.replace(/[^\w\s]/gi, '').replace(' ', '').replace('_', '').length == 11) {
      //     valido = true;
      //   }
      // }

      if ((this.telefoneParaAdicionar.dsContato.replace(/[^\w\s]/gi, '').replace(' ', '').replace('_', '').length == 10) || (this.telefoneParaAdicionar.dsContato.replace(/[^\w\s]/gi, '').replace(' ', '').replace('_', '').length == 11)) {
        valido = true;
      }

      if (valido) {
        let telefoneNovo = {
          "idContato": 0,
          "dsContato": this.telefoneParaAdicionar.dsContato,
          "dsTipoContato": this.telefoneParaAdicionar.dsTipoContato,
          "idTipoContato": 0
        };

        let tipoContatoTemp = this.listaTiposTelefone.filter((tipoContato) => this.telefoneParaAdicionar.dsTipoContato == tipoContato.dsTipoContato)[0];

        if (tipoContatoTemp != null) {
          telefoneNovo.idTipoContato = tipoContatoTemp.idTipoContato;
        }

        if (this.pessoaAtual.telefones.findIndex(i => i.dsContato === telefoneNovo.dsContato) != -1) {
          this.alertService.mostraAlerta("", "Telefone já adicionado!");
        }
        else {
          this.pessoaAtual.telefones.push(telefoneNovo);
          this.telefoneParaAdicionar.dsContato =
            this.telefoneParaAdicionar.dsTipoContato = '';
        }
      } else {
        this.alertService.mostraAlerta("", "O Telefone é inválido.");
      }
    }
  }

  adicionarPeriodoFuncao() {
    if (this.periodoFuncaoParaAdicionar.dataInicio != '' &&
      this.periodoFuncaoParaAdicionar.dataFim != '') {
      let periodoFuncaoNovo = {
        "idPeriodoFuncao": 0,
        "dataInicio": this.periodoFuncaoParaAdicionar.dataInicio,
        "dataFim": this.periodoFuncaoParaAdicionar.dataFim,
        "idPessoaFuncao": 0,
        "portarias": []
      };

      if (this.pessoaAtual.telefones.findIndex(i => i.dataInicio === periodoFuncaoNovo.dataInicio &&
        i.dataFim === periodoFuncaoNovo.dataFim) != -1) {
        this.alertService.mostraAlerta("", "Período já adicionado!");
      } else {

        this.clearDateRange();

        this.pessoaFuncaoAtual.listaPeriodoFuncao.push(periodoFuncaoNovo);
        this.periodoFuncaoParaAdicionar.dataInicio =
          this.periodoFuncaoParaAdicionar.dataFim = '';
      }
    }
  }

  adicionarPortaria(periodoFuncao) {

    let modal = this.modalCtrl.create(ModalPortariasPage,
      {
        periodoFuncao: periodoFuncao,
        jurisdicionado: this.isJurisdicionado,
        idModuloPca: this.codigoModulo,
        isCGE: this.isCGE,
        analise: this.analise
      });

    modal.onDidDismiss(retornoModal => {

      // console.log(retornoModal);
      if (retornoModal && retornoModal.salvar && this.isJurisdicionado) {

        //this.removerPeriodoFuncao(periodoFuncao);

        //retornoModal.periodoFuncao.portarias = retornoModal.periodoFuncao.portarias.filter(function (element) {
        //return element !== undefined;
        //});

        // retornoModal.periodoFuncao.idPeriodoFuncao = 0;
        //retornoModal.periodoFuncao.portarias.forEach(element => {
        //element.idPeriodoFuncao = 0;
        //element.idPortaria = 0;
        //});

        //this.pessoaFuncaoAtual.listaPeriodoFuncao.push(retornoModal.periodoFuncao);

        //retornoModal.salvar = false;

        this.alertService.mostraAlerta("", "Ato de Nomeação salvo com sucesso.");

      }
    });
    modal.present();
  }

  removerTelefone(telefone) {
    let index = this.pessoaAtual.telefones.indexOf(telefone);
    this.pessoaAtual.telefones.splice(index, 1);

    this.telefonesParaRemover.push(telefone);
  }

  removerPeriodoFuncao(periodoFuncao) {

    let index = this.pessoaFuncaoAtual.listaPeriodoFuncao.indexOf(periodoFuncao);
    this.pessoaFuncaoAtual.listaPeriodoFuncao.splice(index, 1);

    if (periodoFuncao.idPeriodoFuncao != undefined && periodoFuncao.idPeriodoFuncao != 0) {
      this.periodosParaRemover.push(periodoFuncao);
    }
  }

  salvarResponsavel() {
    this.loading = true;

    if (this.formularioEhValido()) {

      this.telefonesParaRemover.forEach(telefone => {
        if (telefone.idContato != undefined && telefone.idContato > 0) {
          this.rolresponsaveisService.excluirContato(telefone.idContato).subscribe(res => {
            // console.log(res.mensagem);
          });
        }
      });

      this.pessoaFuncaoAtual.idPca = this.PCAAtiva.id;
      this.pessoaAtual.cpf = this.pessoaAtual.cpf.replace(/[^\w\s]/gi, '');
      this.pessoaAtual.enderecoFuncional.cep = this.pessoaAtual.enderecoFuncional.cep.replace('.', '');
      this.pessoaAtual.enderecoPessoal.cep = this.pessoaAtual.enderecoPessoal.cep.replace('.', '');
      this.pessoaFuncaoAtual.pessoa = this.pessoaAtual;


      this.pessoaFuncaoAtual.pessoa.enderecoPessoal.tipoEndereco = "RESIDENCIAL";
      this.pessoaFuncaoAtual.pessoa.enderecoFuncional.tipoEndereco = "COMERCIAL";

      if (this.periodosParaRemover && this.periodosParaRemover.length > 0) {
        let contador = 1;

        let periodos = "";

        this.periodosParaRemover.forEach(periodo => {
          periodos = periodos + periodo.idPeriodoFuncao;

          if (contador !== this.periodosParaRemover.length) {
            periodos = periodos + ",";
            contador++;
          }
        });
        // console.log(periodos);

        this.rolresponsaveisService.deletarPeriodoFuncao(periodos).subscribe(
          (per) => {
            if (contador == this.periodosParaRemover.length) {
              this.chamarEndPointSalvarResponsavel();
            }

            contador++;
            // console.log(contador);
          },
          (error) => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir os Períodos de Efetiva Gestão: " + error.mensagem);
          }
        );
        // });
      } else {
        this.chamarEndPointSalvarResponsavel();
      }

    }
  }

  
  private chamarEndPointSalvarResponsavel() { 
    this.loading = true;   
    this.rolresponsaveisService.salvarResponsavel(this.pessoaFuncaoAtual).subscribe(pessoaFuncao => {
      this.alertService.mostraAlerta("", "Responsável (" + this.pessoaAtual.nomePessoa + ") salvo com sucesso !");
      this.continuarNaTelaAposSalvarResponsavel(pessoaFuncao);
      // this.editarResponsavel(pessoaFuncao);
    }, error => {
      console.log(JSON.stringify(error));
      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar: " + error.mensagem);
      this.loading = false;
    });
  }


  continuarNaTelaAposSalvarResponsavel(pessoaFuncao) {
    this.telaListagem = false;
    this.telaCriacao = true;
    //this.criacaoResponsavel = true
    this.edicaoResponsavel = true;
    this.cpfPreenchido = true;
    this.funcaoSelecionada = true;
    this.visualizacaoResponsavel = true;
    // this.limparCampos();
    this.carregarRolReponsaveis();

    this.loading = true;
    this.pessoaFuncaoAtual = pessoaFuncao;
    this.pessoaAtual = pessoaFuncao.pessoa;
    this.carregarCidadesDosEnderecosParaEdicao(pessoaFuncao.pessoa);
    this.telaCriacao = this.cpfPreenchido = this.edicaoResponsavel = this.funcaoSelecionada = true;
    this.loading = false;
  }


  formularioEhValido() {
    let ehValido = true;
    let textoValidacoesTitulo = "Favor informar os campos abaixo antes de salvar: <br><br>";
    let textoValidacoes = '';
    let constPularLinhaHTML = "<br>";
    // REGULAR EXPRESSION TO VALIDATE EMAIL FIELDS
    let emailRegularExpression = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.pessoaAtual.nomePessoa == '') {
      textoValidacoes += '- Nome' + constPularLinhaHTML;
    }
    if (this.isNullOrEmpty(this.pessoaAtual.emailFuncional) || !emailRegularExpression.test(this.pessoaAtual.emailFuncional)) {
      textoValidacoes += '- E-mail funcional' + constPularLinhaHTML;
    }
    if (this.isNullOrEmpty(this.pessoaAtual.emailPessoal) || !emailRegularExpression.test(this.pessoaAtual.emailPessoal)) {
      textoValidacoes += '- E-mail pessoal' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoFuncional.cep == '') {
      textoValidacoes += '- CEP (Endereço funcional)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoFuncional.logradouro == '') {
      textoValidacoes += '- Logradouro (Endereço funcional)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoFuncional.numero == '') {
      textoValidacoes += '- Número (Endereço funcional)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoFuncional.bairro == '') {
      textoValidacoes += '- Bairro (Endereço funcional)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoFuncional.idEstado == '') {
      textoValidacoes += '- UF (Endereço funcional)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoPessoal.idCidade == '') {
      textoValidacoes += '- Cidade (Endereço funcional)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoPessoal.cep == '') {
      textoValidacoes += '- CEP (Endereço pessoal)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoPessoal.logradouro == '') {
      textoValidacoes += '- Logradouro (Endereço pessoal)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoPessoal.numero == '') {
      textoValidacoes += '- Número (Endereço pessoal)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoPessoal.bairro == '') {
      textoValidacoes += '- Bairro (Endereço pessoal)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoPessoal.idEstado == '') {
      textoValidacoes += '- UF (Endereço pessoal)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.enderecoPessoal.idCidade == '') {
      textoValidacoes += '- Cidade (Endereço pessoal)' + constPularLinhaHTML;
    }
    if (this.pessoaAtual.telefones.length == 0) {
      textoValidacoes += '- Telefone (Pelo menos 1 deve ser informado)' + constPularLinhaHTML;
    }
    if (this.pessoaFuncaoAtual.idFuncao == '' ||
      this.pessoaFuncaoAtual.idFuncao == 0) {
      textoValidacoes += '- Função' + constPularLinhaHTML;
    }
    if (this.pessoaFuncaoAtual.cargo.idCargo == '' ||
      this.pessoaFuncaoAtual.cargo.idCargo == 0) {
      textoValidacoes += '- Cargo Exercido' + constPularLinhaHTML;
    }
    if (this.pessoaFuncaoAtual.dsDescricaoCargo == '') {
      textoValidacoes += '- Atribuições/Competências conforme legislação' + constPularLinhaHTML;
    }
    if (this.pessoaFuncaoAtual.listaPeriodoFuncao.length == 0) {
      textoValidacoes += '- Período de efetiva gestão (Pelo menos 1 deve ser informado)' + constPularLinhaHTML;
    }

    if (this.pessoaFuncaoAtual.listaPeriodoFuncao != undefined && this.pessoaFuncaoAtual.listaPeriodoFuncao != null && this.pessoaFuncaoAtual.listaPeriodoFuncao.length > 0) {
      this.pessoaFuncaoAtual.listaPeriodoFuncao.forEach(periodo => {

        if (periodo.portarias == undefined || periodo.portarias == null || periodo.portarias.length == 0) {
          textoValidacoes += '- Portaria (Pelo menos 1 deve ser informada) - Período de Efetiva Gestão: ' + periodo.dataInicio + ' a ' + periodo.dataFim + constPularLinhaHTML;
        }
      });
    }


    if ((this.pessoaAtual.enderecoPessoal.logradouro == this.pessoaAtual.enderecoFuncional.logradouro) &&
      (this.pessoaAtual.enderecoPessoal.numero == this.pessoaAtual.enderecoFuncional.numero)) {
      textoValidacoes += '- O Endereço Funcional deve ser diferente do Endereço Pessoal' + constPularLinhaHTML;
    }

    if (this.pessoaFuncaoAtual.dsDescricaoCargo.length <= 30) {
      textoValidacoes += '- As Atribuições/Competências conforme legislação devem ser maiores do que 30 caracteres' + constPularLinhaHTML;
    }

    if (textoValidacoes != '') {
      ehValido = false;
      this.alertService.mostraAlerta("Campos obrigatórios", textoValidacoesTitulo + textoValidacoes);
    }

    return ehValido;
  }

  onEstadoEnderecoPessoalAlterado() {
    if (this.pessoaAtual.enderecoPessoal.idEstado != null) {
      this.rolresponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoPessoal.idEstado).subscribe(data => {
        this.listaCidadesEnderecoPessoal = data;
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
        console.log("erro: " + error);
      });
    } else {
      this.listaCidadesEnderecoPessoal = null;
    }
  }

  onEstadoEnderecoFuncionalAlterado() {
    if (this.pessoaAtual.enderecoFuncional.idEstado != null) {
      this.rolresponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoFuncional.idEstado).subscribe(data => {
        this.listaCidadesEnderecoFuncional = data;
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
        console.log("erro: " + error);
      });
    } else {
      this.listaCidadesEnderecoFuncional = null;
    }
  }

  onCPFAlterado() {
    if (this.validarCPF(this.pessoaAtual.cpf)) {
      this.cpfInvalido = false;
      this.buscarPessoaPorCPF(this.pessoaAtual.cpf);
    }
    else {
      this.cpfPreenchido = false;
    }
  }

  onFuncaoAlterada() {

    this.mesAno = '01/' + this.PCAAtiva.dsAnoexercicio;

    this.funcaoSelecionada = this.pessoaFuncaoAtual.idFuncao != undefined &&
      this.pessoaFuncaoAtual.idFuncao > 0;
  }

  preencherCamposFuncao(pessoaFuncao) {
    this.pessoaFuncaoAtual.idPessoaFuncao = pessoaFuncao.idPessoaFuncao;
    this.pessoaFuncaoAtual.idFuncao = pessoaFuncao.idFuncao;
    this.pessoaFuncaoAtual.dsDescricaoCargo = pessoaFuncao.dsDescricaoCargo;
    this.pessoaFuncaoAtual.cargo.idCargo = pessoaFuncao.cargo.idCargo;
    this.pessoaFuncaoAtual.cargo.nomeCargo = pessoaFuncao.cargo.nomeCargo;
    this.pessoaFuncaoAtual.listaPeriodoFuncao = pessoaFuncao.listaPeriodoFuncao;
    //this.pessoaFuncaoAtual.listaPortarias = pessoaFuncao.listaPortarias;
  }

  existeAlgumCampoFuncaoPreenchido() {
    return this.pessoaFuncaoAtual.dsDescricaoCargo != '' ||
      this.pessoaFuncaoAtual.cargo.idCargo != '' ||
      this.pessoaFuncaoAtual.cargo.nomeCargo != '' ||
      this.pessoaFuncaoAtual.listaPeriodoFuncao.length > 0;
    //  ||
    // this.pessoaFuncaoAtual.listaPortarias.length > 0;
  }

  limparCampos() {
    this.pessoaFuncaoAtual = {
      "idPessoaFuncao": 0,
      "dsDescricaoCargo": "",
      "idPca": this.PCAAtiva.idPca,
      "idFuncao": 0,
      "cargo": {
        "idCargo": "",
        "nomeCargo": ""
      },
      "listaPeriodoFuncao": [
        // ],
        // "listaPortarias": [
      ]
    };

    this.periodosParaRemover = [];
    this.telefonesParaRemover = [];

    this.limparCamposPessoa();

    this.telefoneParaAdicionar = {
      dsContato: '',
      dsTipoContato: ''
    }
    this.limparCamposPeriodoFuncao();
    //this.limparCamposPortaria();

    this.cpfPreenchido =
      this.cpfInvalido = false;
  }

  limparCamposPessoa(limparCpf = true) {
    this.pessoaAtual = {
      "idPessoa": 0,
      "nomePessoa": "",
      "cpf": limparCpf ? '' : this.pessoaAtual.cpf,
      "idEmailPessoal": 0,
      "emailPessoal": "",
      "idEmailFuncional": 0,
      "emailFuncional": "",
      "enderecoPessoal": {
        "idEndereco": 0,
        "logradouro": "",
        "numero": "",
        "complemento": "",
        "bairro": "",
        "idCidade": 0,
        "cidade": "",
        "idEstado": 0,
        "estado": "",
        "cep": "",
        "tipoEndereco": "RESIDENCIAL"
      },
      "enderecoFuncional": {
        "idEndereco": 0,
        "logradouro": "",
        "numero": "",
        "complemento": "",
        "bairro": "",
        "idCidade": 0,
        "cidade": "",
        "idEstado": 0,
        "estado": "",
        "cep": "",
        "tipoEndereco": "COMERCIAL"
      },
      "telefones": [
      ]
    };
  }

  limparCamposPeriodoFuncao() {
    this.periodoFuncaoParaAdicionar = {
      "idPeriodoFuncao": 0,
      "dataInicio": "",
      "dataFim": "",
      "idPessoaFuncao": 0,
      "portarias": []
    }
  }

  limparCamposParaNovaFuncao() {
    this.limparCamposPeriodoFuncao();
    //this.limparCamposPortaria();
    this.pessoaFuncaoAtual.dsDescricaoCargo = '';
    this.pessoaFuncaoAtual.cargo.idCargo = '';
    this.pessoaFuncaoAtual.cargo.nomeCargo = '';
    this.pessoaFuncaoAtual.listaPeriodoFuncao = [];
    //this.pessoaFuncaoAtual.listaPortarias = [];
    this.pessoaFuncaoAtual.idPessoaFuncao = 0;
  }

  validarCPF(cpf) {
    let ehValido = true;

    cpf = cpf.replace(/[^\w\s]/gi, '');

    if (cpf == '') {
      this.cpfInvalido = false;
      return false;
    }

    if (cpf.length != 11) {
      this.cpfInvalido = false;
      return false;
    }

    // Elimina CPFs invalidos conhecidos
    if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
      cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
      cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
      this.cpfInvalido = true;
      return false;
    }

    // Valida 1o digito
    let add = 0;
    for (let i = 0; i < 9; i++)
      add += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(9))) {
      this.cpfInvalido = true;
      return false;
    }

    // Valida 2o digito
    add = 0;
    for (let i = 0; i < 10; i++) {
      add += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(10))) {
      this.cpfInvalido = true;
      return false;
    }

    return ehValido;
  }

  onDateRangeChanged(event: IMyDateRangeModel) {

    if (event.formatted !== '') {

      this.border = '1px solid #CCC';

      this.periodoFuncaoParaAdicionar.dataInicio = new Date(event.beginJsDate).toLocaleDateString('pt-br');
      this.periodoFuncaoParaAdicionar.dataFim = new Date(event.endJsDate).toLocaleDateString('pt-br');
    }
    else {
      this.selectedText = '';
      this.border = 'none';
    }
  }

  onDataNascimentoChanged(event: IMyDateModel) {
    if (event.formatted !== '') {
      this.pessoaAtual.dataNascimento = new Date(event.jsdate).toLocaleDateString('pt-br');
    }
  }

  clearDateRange(): void {
    this.selectedDateRange = null;
  }

  getCopyOfPublicacaoOptions(): IMyDpOptions {
    return JSON.parse(JSON.stringify(this.myDatePickerPublicacaoOptions));
  }

  getCopyOfNomeacaoOptions(): IMyDpOptions {
    return JSON.parse(JSON.stringify(this.myDatePickerNomeacaoOptions));
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  printData() {

    var doc = new jsPDF("l");
    var totalPagesExp = "{total_pages_count_string}";

    var pageContent = function (data) {
      // HEADER
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.setFontStyle('normal');

      doc.text("Rol de Responsáveis", data.settings.margin.left + 15, 22);

      // FOOTER
      var str = "Page " + data.pageCount;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    };

    var columns = [
      { title: "Nome", dataKey: "nome" },
      { title: "CPF", dataKey: "cpf" },
      { title: "Categoria", dataKey: "categ" },
      { title: "Cargo", dataKey: "cargo" },
      { title: "Início Efetiva Gestão", dataKey: "inicio" },
      { title: "Fim Efetiva Gestão", dataKey: "fim" }
    ];

    let rows = [];

    this.rolDeResponsaveis.forEach(rol => {
      rol.listaPessoaFuncao.forEach(pessoa => {
        pessoa.listaPeriodoFuncao.forEach(periodoFuncao => {
          var item = {
            "nome": pessoa.pessoa.nomePessoa,
            "cpf": this.cpf_mask(pessoa.pessoa.cpf),
            "categ": rol.dsFuncao,
            "cargo": pessoa.cargo.nomeCargo,
            "inicio": periodoFuncao.dataInicio,
            "fim": periodoFuncao.dataFim
          };

          rows.push(item);
        });
      });
    });

    doc.autoTable(columns, rows, {
      theme: 'grid',
      addPageContent: pageContent,
      margin: { top: 30 },
      styles: {
        overflow: 'linebreak',
        columnWidth: 'auto',
        fontSize: 8
      },
      columnStyles: {
        desc: { columnWidth: 'auto' }
      }
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('rol_responsaveis.pdf');
  }

  private isNullOrEmpty(value: any): boolean {
    return !value || (value && value === '') || (value && value.toString().trim() === '');
  }

  submeterModulo() {
    this.rolresponsaveisService.submeterModuloRol(this.rolDeResponsaveis).subscribe(data => {
      this.alertService.mostraAlerta("", "Mensagem:" + data.mensagem);
    }, error => {
      this.alertService.mostraAlerta("", "Mensagem:" + error.mensagem);
    });
  }

  selecionarTodos() {
    setTimeout(() => {
      this.rolDeResponsaveis.forEach(
        rol => {
          rol.listaPessoaFuncao.forEach(item => {
            item.checked = this.selecionarTodosChecked;
          });
        });
    });
  }

  selecionarItem() {
    let totalItems = 0;

    this.rolDeResponsaveis.forEach(
      rol => {
        totalItems += rol.listaPessoaFuncao.length;
      });

    let checked = 0;

    this.rolDeResponsaveis.forEach(
      rol => {
        rol.listaPessoaFuncao.map(obj => {
          if (obj.checked) checked++;
        });
      });

    this.selecionarTodosChecked = checked == totalItems;

  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/rol-responsaveis/rol-responsaveis.ts